import { slugify, uniqueSlug } from "../../utils/slugify";

export default {
  data() {
    return {
      autoId: null
    };
  },
  mounted() {
    if (this.id) return;
    var text = this.getAutoIdText();
    if (!text) return;
    var slug = slugify(text);
    if (!slug) return;
    var id = uniqueSlug(slug);
    this.$el.id = id;
    this.autoId = id;
  },
  methods: {
    getAutoIdText() {
      return null;
    }
  }
};
